/**
 * La cave › Mouvements et inventaire (/cave/mouvements) — journal immuable filtrable.
 */
import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { caveApi } from '../../services/api';
import { formatDate, formatTime, formatSigned, formatEuro } from '../../utils/format';
import { Spinner, Tag, SegmentedControl } from '../../components/ui/kit';
import { WineColorDot } from '../../components/wine/wine';

const TYPE_TAGS = { entree: 'Entrée', sortie: 'Sortie', inventaire: 'Inventaire', deplacement: 'Déplacement', correction: 'Annulation' };
const FILTERS = [
  { value: '', label: 'Tous' }, { value: 'entree', label: 'Entrées' },
  { value: 'sortie', label: 'Sorties' }, { value: 'inventaire', label: 'Inventaires' },
];

export default function Mouvements() {
  const [type, setType] = useState('');
  const [q, setQ] = useState('');
  const { data: movements = [], isLoading } = useQuery({
    queryKey: ['all-movements', type, q],
    queryFn: () => caveApi.movements({ type, q }),
  });

  return (
    <div className="p-4 md:p-6 max-w-[1000px]">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <SegmentedControl options={FILTERS} value={type} onChange={setType} testId="mvt-filter" />
        <input className="vd-input h-8 max-w-[220px] ml-auto" placeholder="Recherche…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="mvt-search" />
      </div>
      {isLoading ? <Spinner /> : (
        <div className="vd-card overflow-hidden">
          <table className="w-full text-[13.5px]" data-testid="movements-table">
            <thead>
              <tr className="text-left kicker">
                <th className="py-2.5 px-3">Date</th><th className="py-2.5 px-3">Heure</th>
                <th className="py-2.5 px-3">Type</th><th className="py-2.5 px-3">Référence</th>
                <th className="py-2.5 px-3">Motif / détail</th><th className="py-2.5 px-3 text-right">Qté</th>
                <th className="py-2.5 px-3 text-right">Prix</th>
              </tr>
            </thead>
            <tbody>
              {movements.map((m) => (
                <tr key={m.id} className="hair-t" data-testid={`mvt-${m.id}`}>
                  <td className="py-2.5 px-3 nums text-n700">{formatDate(m.date)}</td>
                  <td className="py-2.5 px-3 nums text-n600">{formatTime(m.date)}</td>
                  <td className="py-2.5 px-3"><Tag tone={m.type === 'correction' ? 'neutral' : 'accent'}>{TYPE_TAGS[m.type] || m.type}</Tag></td>
                  <td className="py-2.5 px-3"><span className="flex items-center gap-2">{m.color && <WineColorDot color={m.color} size={9} />}{m.label}</span></td>
                  <td className="py-2.5 px-3 text-n600">{m.motif_label}{m.note && m.type !== 'sortie' ? ` · ${m.note}` : ''}</td>
                  <td className={`py-2.5 px-3 text-right nums ${m.quantity > 0 ? 'text-gold700' : ''}`}>{formatSigned(m.quantity)}</td>
                  <td className="py-2.5 px-3 text-right nums text-n600">{m.unit_price ? formatEuro(m.unit_price) : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
